import filenamify, { type Options } from 'filenamify/browser';

/**
 * Common filesystems allow 255 characters per name component. Upload flows
 * sanitize a base name before appending the extension, so reserve 10 characters
 * for that extension instead of using filenamify's 100 character default.
 */
export const PORTAL_FILENAME_BASE_MAX_LENGTH = 245;

export const portalFilenamify = (name: string, options?: Options) => {
  return filenamify(name, {
    replacement: '_',
    maxLength: PORTAL_FILENAME_BASE_MAX_LENGTH,
    ...options,
  });
};
